import { useSyncExternalStore } from 'react';

import { isPhoneOrHighScreen } from '@/utilities/sizeUtils';

function subscribeToWindowResize(handleStoreChange: () => void) {
  window.addEventListener('resize', handleStoreChange);

  return () => window.removeEventListener('resize', handleStoreChange);
}

export function useIsPhoneOrHighScreen() {
  return useSyncExternalStore(subscribeToWindowResize, isPhoneOrHighScreen, () => false);
}
